import { useStore } from "@/provider/store";
import { PillarTabs } from "@/components/daylight-insight/PillarTabs";
import { PillarPage } from "./PillarPage";
import { CurrentStatePage } from "./CurrentStatePage";
import { DashboardMetricsSkeleton } from "@/components/skeleton/DashboardMetricsSkeleton";

/**
 * Operating View — the original single-file "operating" route. Renders the
 * pillar tab strip and either the Current State page or a pillar page.
 *
 * The tab list and the active pillar both come from the store: the tabs are the
 * server's dashboard/metric-category list, and the store already resolves the
 * active pillar to the server's default (or the first available tab) whenever
 * the current one isn't renderable.
 */
export function DashboardInsight() {
  const s = useStore();
  // WHICH page shell renders the active tab is the dashboard's own spec: the
  // ordinary filtered metrics page, or the unfiltered as-of-now snapshot. No
  // tab key is special-cased here any more — Current State is a dashboard whose
  // spec says `page: "snapshot"`, and a second such dashboard would need no
  // change to this file.
  const spec = s.specFor(s.pillar);
  const Page = spec?.page === "snapshot" ? CurrentStatePage : PillarPage;
  return (
    <>
      <PillarTabs pillar={s.pillar} setPillar={s.setPillar} />
      {/* `key={s.pillar}` remounts the page on every dashboard switch, so all of
          its filter selections start fresh rather than carrying over. */}
      {s.tabs.length === 0 ? (
        s.configLoading ? (
          <DashboardMetricsSkeleton />
        ) : (
          <div className="pp">
            <div style={{ color: "var(--ink-3)", fontSize: 14, marginTop: 20 }}>
              No dashboards have been granted to this role.
            </div>
          </div>
        )
      ) : (
        <Page key={s.pillar} pillarK={s.pillar} />
      )}
    </>
  );
}
